// extracted by mini-css-extract-plugin
module.exports = {"main":"layoutManager_main__V2mGE","main_event":"layoutManager_main_event__UYgTk"};